import { Pipe, PipeTransform } from '@angular/core';
import { NgxMaskPipe } from 'ngx-mask';

@Pipe({
  name: 'phone',
  pure: true,
  standalone: true,
})
export class PhoneMaskPipe implements PipeTransform {
  constructor(private pipe: NgxMaskPipe) {}

  transform(value) {
    if (!value) return '';

    if (value.substring(0, 2) === '+1') {
      value = value.replace('+1', '');
    }

    if (value.substring(0, 1) === '+') {
      return value;
    } else {
      return this.pipe.transform(value, '(000) 000-0000');
    }
  }
}
